const FLOWCHART_DIRECTION_RE = /^(\s*)(?:flowchart|graph)\s+(?:TB|TD|BT|RL|LR)\b/im;

export const normalizeUserFlowDirection = (content: string): string => (
  content.replace(FLOWCHART_DIRECTION_RE, '$1flowchart LR')
);
